import { useContext } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ConfigContext } from "../../../../config/configContext";
import InstagramLogo from "./svgs/instagram";
import FacebookLogo from "./svgs/facebook";
import TwitterLogo from "./svgs/twitter";

const MotionLink = motion(Link);

function Footer() {
  const {
    footer: { links, legalLinks, socials },
    logo,
    name,
  } = useContext(ConfigContext)!;

  return (
    <footer className="relative bg-neutral px-4 pb-12 pt-0 text-neutral-content">
      <div className="absolute -top-12 left-0 h-12 w-full rounded-t-[50%] bg-neutral" />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        className="relative mt-12 w-full"
      >
        <div className="mx-auto mb-8 flex w-full max-w-screen-lg justify-end">
          <Link to="/" className="shrink-0" aria-label={name}>
            <img className="h-12 w-auto md:h-16" src={logo} alt="" />
          </Link>
        </div>
        <nav className="flex flex-col items-start gap-4">
          {links.map(({ title, href }, index) => (
            <MotionLink
              key={index}
              to={href}
              variants={{
                hidden: { opacity: 0, x: "-100%" },
                visible: { opacity: 1, x: 0 },
              }}
              transition={{ delay: index * 0.25 }}
              className="link block whitespace-nowrap text-xl font-bold uppercase text-primary no-underline hover:text-primary/50 md:text-4xl"
            >
              {title}
            </MotionLink>
          ))}
        </nav>
        <aside className="mt-4 flex w-full flex-col items-center justify-between overflow-hidden md:flex-row lg:overflow-visible">
          <div className="flex w-full items-center gap-3 text-primary">
            {socials?.facebook && (
              <motion.a
                variants={{
                  hidden: { opacity: 0, x: "-100%" },
                  visible: { opacity: 1, x: 0 },
                }}
                transition={{ delay: 0.25 }}
                className="h-8 w-8 hover:text-primary/50"
                target="_blank"
                rel="noreferrer"
                href={socials.facebook}
              >
                <FacebookLogo />
              </motion.a>
            )}
            {socials?.instagram && (
              <motion.a
                variants={{
                  hidden: { opacity: 0, x: "-100%" },
                  visible: { opacity: 1, x: 0 },
                }}
                transition={{ delay: 0.5 }}
                className="h-8 w-8 hover:text-primary/50"
                target="_blank"
                rel="noreferrer"
                href={socials.instagram}
              >
                <InstagramLogo />
              </motion.a>
            )}
            {socials?.twitter && (
              <motion.a
                variants={{
                  hidden: { opacity: 0, x: "-100%" },
                  visible: { opacity: 1, x: 0 },
                }}
                transition={{ delay: 0.75 }}
                className="h-8 w-8 hover:text-primary/50"
                target="_blank"
                rel="noreferrer"
                href={socials.twitter}
              >
                <TwitterLogo />
              </motion.a>
            )}
          </div>
          <div className="mb-4 mt-8 flex flex-wrap gap-4 md:m-0">
            <MotionLink
              to="/privacy-policy"
              variants={{
                hidden: { opacity: 0, scale: 0.4 },
                visible: { opacity: 1, scale: 1 },
              }}
              transition={{ delay: 0.35 }}
              className="font-bold text-primary hover:text-primary/50 lg:whitespace-nowrap"
            >
              Politique de confidentialité et cookies
            </MotionLink>
            {legalLinks.termsAndConditions && (
              <motion.a
                variants={{
                  hidden: { opacity: 0, scale: 0.4 },
                  visible: { opacity: 1, scale: 1 },
                }}
                transition={{ delay: 0.5 }}
                className="font-bold text-primary hover:text-primary/50 lg:whitespace-nowrap"
                href="/terms-and-conditions"
              >
                Conditions d&apos;utilisation
              </motion.a>
            )}
          </div>
          <motion.p
            variants={{
              hidden: { opacity: 0, scale: 0.4 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{ delay: 1 }}
            className="mt-0.5 md:ml-4 md:whitespace-nowrap"
          >
            Tous droits réservés © {new Date().getFullYear()} — Ministère de la Santé
          </motion.p>
        </aside>
      </motion.div>
    </footer>
  );
}

export default Footer;
